import { FC } from "react";

import  TableVacancyCreate  from '../../table/recruiting/tableVacancyCreate'

interface ISectionOptions {
  title?: string;
}

const VacancyCreateNewSection: FC<ISectionOptions> = () => {
  return (
    <TableVacancyCreate/>
  );
};

export default VacancyCreateNewSection;
